import { createAction } from '@reduxjs/toolkit';

const SHEETS_MANUAL_MODE_NAMESPACE = 'sheetsManager/manualMode';

export const saveManualModeChanges = createAction<boolean | undefined>(`${SHEETS_MANUAL_MODE_NAMESPACE}/save`);

export const discardManualModeChanges = createAction<boolean | undefined>(`${SHEETS_MANUAL_MODE_NAMESPACE}/discard`);
